import * as React from 'react';
import './style.scss';
import { Card as AntdCard } from 'antd';
import { getIconPath } from 'core/utils/getIconPath';
import { digitSperator, ToEn } from 'core/utils/decimalExtentions';
import { EditUserBalanceCardProps } from './type';
import { PushpinOutlined } from '@ant-design/icons';
import { Button, buttonType } from 'components/button/button';
import { Modal } from 'components';
import { useState } from 'react';
import { Input } from 'components/input/input';
import OtpInput from 'react-otp-input';
import { post, responseValidator } from 'apis/api';
import { API } from 'apis';

export const EditUserBalanceCard: React.FC<EditUserBalanceCardProps> = (props: EditUserBalanceCardProps) => {
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [editBalance, setEditBalance] = useState<number>(props.item.balance);
    const [codeValue, setCodeValue] = useState<string>();
    const item = props.item;

    function editSubmitHandler() {
        setConfirmLoading(true);
        const body = {
            userId: props.userId,
            googleAuthCode: codeValue,
            assets: [{ symbol: props.item.symbol, amount: editBalance }],
        };

        post(API.wallet.updateWallet, body)
            .then((res: any) => {
                if (responseValidator(res.status)) {
                    props.onConfirm();
                    setIsEditModalOpen(false);
                }
            })
            .finally(() => setConfirmLoading(false));
    }

    return (
        <AntdCard
            extra={props.isPinned && <PushpinOutlined />}
            hoverable
            className="assets"
            title={
                <div className="assets-title">
                    <img alt={item.symbol} src={getIconPath(item.symbol.toLowerCase())} />
                    <label>{item.name}</label>
                    <span className="en">{item.symbol}</span>
                </div>
            }
        >
            <Modal setIsOpen={setIsEditModalOpen} isOpen={isEditModalOpen} className="assets-edit-user-balance-modal">
                <div className="assets-edit-user-balance-modal-container">
                    <Input
                        label="موجودی"
                        placeholder="موجودی مورد نظر را وارد نمایید"
                        value={digitSperator(editBalance)} // Controlled value
                        onChange={(e) => {
                            const value = e.target.value.replace(/,/g, ''); // Remove commas
                            setEditBalance(parseFloat(value) || 0); // Trigger a re-render
                        }}
                    />
                    <p>کد دوعاملی گوگل</p>
                    <OtpInput
                        renderInput={(props) => <input {...props} />}
                        value={codeValue}
                        onChange={(value) => setCodeValue(ToEn(value))}
                        numInputs={6}
                        shouldAutoFocus
                        inputStyle={'pmx-otp-input'}
                        containerStyle={'pmx-otp-input-container'}
                    />
                    <div className="assets-edit-user-balance-modal-container-buttons">
                        <Button
                            disabled={!codeValue || codeValue === '' || editBalance === undefined}
                            type={buttonType.info}
                            text="اعمال"
                            onClick={editSubmitHandler}
                            loading={confirmLoading}
                        />
                        <Button type={buttonType.error} text="لغو" onClick={() => setIsEditModalOpen(false)} />
                    </div>
                </div>
            </Modal>
            <div className="assets-container">
                <div className="assets-container-item">
                    <label>موجودی: </label>
                    <span>{digitSperator(item.balance)} واحد</span>
                </div>
                <div className="assets-container-item">
                    <label>آخرین قیمت: </label>
                    <span>{digitSperator(item.lastPrice)} دلار</span>
                </div>
                <div className="assets-container-item">
                    <label>معادل تومانی: </label>
                    <span>{digitSperator(item.value)} تومان</span>
                </div>

                <Button
                    htmlType="button"
                    type={buttonType.info}
                    text="اصلاح"
                    onClick={() => {
                        setIsEditModalOpen(true);
                        setEditBalance(props.item.balance);
                        setCodeValue('');
                    }}
                />
            </div>
        </AntdCard>
    );
};
